import React, { useState } from 'react';
import css from './SectionQualifications.css';
import ScoreBadge from '../../../../components/ScoreBadge/ScoreBadge';
import { EditComponent } from '..';
import { Button, QualificationModal } from '../../../../components';
import {
    HORSE_QUALIFICATION_BASIC_TRAINING,
    horseQualifications,
} from '../../../../marketplace-custom-config';
import classNames from 'classnames';

const SectionQualifications = ({
    authorDisplayName,
    publicData,
    isLoggedOut,
    isOwnListing,
    editParams,
    isMobile,
    scoreData,
    isDraftVariant,
    currentListing,
}) => {
    const [qualificationKey, setQualificationKey] = useState(null);

    const { requiredQualificationLevel } = publicData || {};
    const noQualificationRequired = requiredQualificationLevel === 'keine';

    const noData =
        !requiredQualificationLevel ||
        !horseQualifications[requiredQualificationLevel] ||
        noQualificationRequired;

    const showNoDataForLoggedInViewer =
        (isDraftVariant || (!isOwnListing && !isLoggedOut)) && noData;
    const editAllowed = !noData && isOwnListing && !isDraftVariant;
    const showAddNewItemButton = isOwnListing && noData && !isDraftVariant;
    const showScoreData = scoreData && typeof scoreData.qualificationScore === 'number';

    if (isLoggedOut && noData) return null;

    return (
        <>
            <div className={css.root}>
                <h2
                    className={classNames(css.title, {
                        [css.titleWithScore]: Boolean(showScoreData),
                    })}
                >
                    <span>{isMobile ? 'Gew. Qualifikationen' : 'Gewünschte Qualifikationen'}</span>
                    {editAllowed ? (
                        <EditComponent pageName="qualifications" editParams={editParams} />
                    ) : null}
                    {showScoreData && (
                        <div className={css.matchingContainer}>
                            <ScoreBadge
                                scoreData={{ total: scoreData.qualificationScore, maxScore: 100 }}
                            />
                        </div>
                    )}
                </h2>

                <div className={css.sectionContent}>
                    {!noData && (
                        <div className={css.qBoxes}>
                            <p className={css.qBox}>
                                <span className={css.qBoxLabel}>
                                    {horseQualifications[requiredQualificationLevel]?.label}
                                </span>
                                <span
                                    className={css.qBoxActionLink}
                                    onClick={() =>
                                        setQualificationKey(
                                            noQualificationRequired
                                                ? HORSE_QUALIFICATION_BASIC_TRAINING
                                                : requiredQualificationLevel
                                        )
                                    }
                                >
                                    Qualifikationen anzeigen
                                </span>
                            </p>
                        </div>
                    )}
                    {showNoDataForLoggedInViewer && (
                        <p>{authorDisplayName} hat keine Qualifikationen hinzugefügt.</p>
                    )}
                    {showAddNewItemButton && (
                        <EditComponent
                            pageName="qualifications"
                            editParams={editParams}
                            rootClassName={css.addNewItemButton}
                        >
                            <Button>Qualifikationen hinzufügen</Button>
                        </EditComponent>
                    )}
                </div>
            </div>

            {qualificationKey && (
                <QualificationModal
                    isOpen
                    onClose={() => setQualificationKey(null)}
                    currentListing={currentListing}
                    initialQualification={qualificationKey}
                />
            )}
        </>
    );
};

export default SectionQualifications;
